import React from "react";
import PurchaseRequestForm from "../components/PurchaseRequestForm";
import { Sparkles, ShieldCheck, Wrench, Clock } from "lucide-react";

const STEPS = [
  { icon: Sparkles, title: "1. Daten eingeben", desc: "Beschreiben Sie Ihr Fahrzeug – auch wenn es beschädigt oder nicht fahrbereit ist." },
  { icon: Clock, title: "2. Sofortige KI-Einschätzung", desc: "Unsere KI liefert in Sekunden eine realistische unverbindliche Preisspanne." },
  { icon: Wrench, title: "3. Persönliche Prüfung", desc: "Wir prüfen Ihr Fahrzeug vor Ort oder per Foto-Übermittlung." },
  { icon: ShieldCheck, title: "4. Verbindliches Angebot", desc: "Sie erhalten ein konkretes Ankaufsangebot und können sofort verkaufen." },
];

const SellCar = () => (
  <div className="bg-[var(--na-bg)] pt-12 pb-24" data-testid="sell-car-page">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--na-red)] font-semibold mb-3">
        Fahrzeug-Ankauf · KI-Vorbewertung
      </p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter leading-[1.05]">
        NA Automobile <span className="silver-gradient-text">kauft Ihr Fahrzeug</span>
      </h1>
      <p className="text-zinc-300 mt-5 max-w-2xl leading-relaxed">
        Egal ob top gepflegt oder mit Motorschaden – wir kaufen Ihr Fahrzeug zum fairen Preis.
        Beschreiben Sie Ihr Auto online und erhalten Sie eine sofortige unverbindliche
        Einschätzung durch unsere KI.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
        {STEPS.map((s) => (
          <div key={s.title} className="bg-[#2E2E3C] border border-silver-soft rounded-2xl p-5">
            <div className="w-9 h-9 rounded-xl bg-[var(--na-red)]/15 text-[var(--na-red)] flex items-center justify-center mb-3">
              <s.icon className="w-4 h-4" strokeWidth={1.7} />
            </div>
            <p className="font-display font-semibold text-white text-sm">{s.title}</p>
            <p className="text-xs text-zinc-400 mt-1.5 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-16">
        <PurchaseRequestForm />
      </div>
    </div>
  </div>
);

export default SellCar;
